// Phase 2 — Bulk Settlement Type modal extracted from Merchants.jsx.
// Pure presentational; parent owns the state + apply handler.

import { Btn, Modal, Select } from "@/components/Shared";

const SETTLEMENT_OPTIONS = ["IS", "T+1"];

export default function MerchantBulkSettlementModal({ open, onClose, value, setValue, count, onApply }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Set Settlement Type · ${count} merchant${count === 1 ? "" : "s"}`}
      testid="bulk-settlement-modal"
      size="md"
    >
      <div className="space-y-4">
        <p className="text-[12.5px] text-[var(--muted)] leading-relaxed">
          Sets the same Settlement Type on all selected merchants. Leave blank to clear.
        </p>
        <div>
          <label className="text-[11px] uppercase text-[var(--muted)] font-semibold tracking-wider">Settlement Type</label>
          <Select
            testid="bulk-settlement-value"
            options={SETTLEMENT_OPTIONS}
            value={value}
            onChange={setValue}
            placeholder="— clear —"
          />
          <div className="text-[10.5px] text-[var(--muted)] mt-1"><b>IS</b> = Instant Settlement · <b>T+1</b> = next-business-day.</div>
        </div>
        <div className="flex justify-end gap-2 pt-1">
          <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
          <Btn variant="accent" testid="bulk-settlement-apply" onClick={onApply}>
            Apply to {count}
          </Btn>
        </div>
      </div>
    </Modal>
  );
}

export { SETTLEMENT_OPTIONS };
